import { render, staticRenderFns } from "./Buildings.vue?vue&type=template&id=ff6eb3d6&"
import script from "./Buildings.vue?vue&type=script&lang=ts&"
export * from "./Buildings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports